/**
 * Single source of truth for resolving deductible shown in plan footers (desktop select-your-plan
 * and mobile sticky footer). Store `currentSelectedPlan` often omits `term.deductible` on first paint
 * while `allPlansPlanBasedTerm` or parent inputs already contain it.
 */

export function isDeductibleDefined(v: unknown): boolean {
  return v !== undefined && v !== null && v !== '';
}

export interface ResolveFooterDeductibleParams {
  /** NgRx `selectedPlan` slice */
  selectedPlanState: any;
  /** Mobile footer: `@Input() plan` (optional) */
  inputPlan?: any;
  /** Select-your-plan: `_deductible` @Input */
  inputDeductible?: any;
  /** Select-your-plan: `plans` @Input */
  plansInput?: any[];
  chosenPlan?: any;
}

/**
 * Returns the first defined deductible from a merged fallback chain (store + optional inputs).
 */
export function resolveFooterDeductible(params: ResolveFooterDeductibleParams): string | number | null {
  const { selectedPlanState: val, inputPlan, inputDeductible, plansInput, chosenPlan } = params;
  const current = val?.currentSelectedPlan;
  const allPlans = val?.allPlansPlanBasedTerm;

  const primary = current ?? inputPlan ?? null;

  if (isDeductibleDefined(primary?.term?.deductible)) {
    return primary.term.deductible;
  }

  const ref = primary?.plan?.referenceNumber;
  if (ref && Array.isArray(allPlans)) {
    const matched = allPlans.find((p: any) => p?.plan?.referenceNumber === ref);
    if (isDeductibleDefined(matched?.term?.deductible)) {
      return matched.term.deductible;
    }
  }

  const activeFromStore = Array.isArray(allPlans) ? allPlans.find((p: any) => p.active) : null;
  if (isDeductibleDefined(activeFromStore?.term?.deductible)) {
    return activeFromStore.term.deductible;
  }

  if (isDeductibleDefined(primary?.plan?.deductible)) {
    return primary.plan.deductible;
  }

  if (isDeductibleDefined(inputDeductible)) {
    return inputDeductible;
  }

  const activeInput = Array.isArray(plansInput) ? plansInput.find((p: any) => p.active) : null;
  if (isDeductibleDefined(activeInput?.term?.deductible)) {
    return activeInput.term.deductible;
  }
  if (isDeductibleDefined(activeInput?.plan?.deductible)) {
    return activeInput.plan.deductible;
  }

  if (isDeductibleDefined(chosenPlan?.term?.deductible)) {
    return chosenPlan.term.deductible;
  }
  if (isDeductibleDefined(chosenPlan?.plan?.deductible)) {
    return chosenPlan.plan.deductible;
  }

  if (inputPlan && ref && inputPlan?.plan?.referenceNumber === ref) {
    if (isDeductibleDefined(inputPlan?.term?.deductible)) {
      return inputPlan.term.deductible;
    }
    if (isDeductibleDefined(inputPlan?.plan?.deductible)) {
      return inputPlan.plan.deductible;
    }
  }

  return null;
}
